export default __webpack_public_path__ + "static/media/ashgourd.038d55f3.png";